/**
 * Agrupa movimientos de abonos por concepto UI y los ordena.
 *
 * @param {Array} abonos - Array de AbonoAgrupado (con .movimientos[])
 * @returns {{ conceptos: Array<{concept, total}>, totalGeneral: number }}
 */
export function agruparMovimientosPorConcepto(abonos) {

const MOVIMIENTO_LABEL = {
  cobranza: "Gastos de Cobranza",
  iva: "IVA",
  interesMoratorio: "Interés de mora",
  conceptoFirmaElectronica: "Firma Electrónica",
  administracion: "Administración",
  interesCorriente: "Interés corriente",
  capital: "Capital",
};

const ORDEN_CONCEPTOS = [
  "Gastos de Cobranza",
  "IVA",
  "Interés de mora",
  "Administración",
  "Firma Electrónica",
  "Interés corriente",
  "Capital",
];

  let totalGeneral = 0;

  const acumulado = abonos
    .flatMap((abono) => abono.movimientos)
    .reduce((acc, mov) => {
      const amount = mov.amount || 0;
      const concept = MOVIMIENTO_LABEL[mov.movementType] ?? mov.movementType;

      totalGeneral += amount;
      acc[concept] = (acc[concept] ?? 0) + amount;

      return acc;
    }, {});

  const conceptos = Object.entries(acumulado)
    .map(([concept, total]) => ({ concept, total }))
    .sort(
      (a, b) =>
        ORDEN_CONCEPTOS.indexOf(a.concept) - ORDEN_CONCEPTOS.indexOf(b.concept),
    );

  return { conceptos, totalGeneral };
}
